import { TranslationService } from "../../../../services/TranslationService";
import { CompanySettings } from "../../../../entities/company/Company/CompanySettings";
import { useContext, useState } from "react";
import Loading from "../../../shared/components/Loading";
import ConfigurationContext from "../../ConfigurationContext";
import CompanyService from "../../../../services/CompanyService";
import Dropdown from "../../../shared/components/Dropdown";

type DropdownItemType = {
  value: null | string;
  text: string;
};

type DropdownSelectWrapperType = {
  initialValue?: string | null;
  action?: keyof CompanySettings;
  title?: string;
  items: DropdownItemType[];
  fullSize?: boolean;
};

export const AutomaticActionsLanguage = ({
  title,
  action,
  initialValue = null,
  items,
  fullSize = false
}: DropdownSelectWrapperType) => {
  const [loading, setLoading] = useState(false);
  const { refreshConfigValues } = useContext(ConfigurationContext);

  const handleSelect = (valueUpdated: any) => {
    setLoading(true);

    action &&
      CompanyService.setConfigCompany({ [action]: valueUpdated }).finally(
        async () => {
          await refreshConfigValues();
          await setLoading(false);
        }
      );
  };

  return loading ? (
    <Loading />
  ) : (
    <div
      className={`d-flex ${fullSize ? "" : "col-md-8"} justify-content-between align-items-center`}
    >
      {title && (
        <td className="col py-0">
          <div className="configuration-display-item">
            {TranslationService.getTranslation(title)}
          </div>
        </td>
      )}
      <td className={`col${title ? "-sm-5" : ""} py-0`}>
        <Dropdown items={items} onChange={handleSelect} value={initialValue} />
      </td>
    </div>
  );
};
